import styled from 'styled-components'
import { colors } from '@blocket/blocket-ui'

import footerColorBar from '../FooterColorBar.svg.js'
import { ie11media } from '../constants'

export default styled.div`
  background-color: white;
  border-top: 1px solid ${colors.grey300};
  position: relative;
  width: 100%;
  bottom: 0;
  overflow: hidden;

  .footer {
    padding: 16px;
    margin: 16px 0;
    &::before {
      ${ie11media} {
        background-size: 1280px 13px;
      }
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      min-width: 2000px;
      width: 100%;
      height: 13px;
      content: '';
      background-image: url(${footerColorBar});
      background-repeat: repeat-x;
    }
  }
`
